import Image from 'next/image';
import { Suspense, useEffect, useRef } from 'react';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

import { classNames } from '@/shared/lib';
import { Icons } from '@/shared/ui';

import 'swiper/css';
import 'swiper/css/navigation';

// TODO: Experiment
// const imageLoader = ({ src, width }: ImageLoaderProps) => {
//   return `${src}?crop=smart&width=${width}&height=${width}&blur=5`;
// };

interface Props {
  images: string[];
  setSelectedImage: (index: number) => void;
  selectedImage: number;
  imageErrors: boolean[];
  onImageError: (index: number) => void;
}

export default function VerticalThumbnails({
  images,
  setSelectedImage,
  selectedImage,
  imageErrors,
  onImageError
}: Props) {
  const swiperRef = useRef<SwiperRef | null>(null);

  useEffect(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slideTo(selectedImage);
  }, [selectedImage]);

  return (
    <Suspense fallback={<Icons.InfiniteLoadingDotsIcon />}>
      <Swiper
        direction="vertical"
        ref={swiperRef}
        spaceBetween={10}
        slidesPerView={3}
        scrollbar
        mousewheel
        className="h-full overflow-auto"
        modules={[Scrollbar, Mousewheel]}
      >
        {images.map((picture, index) => (
          <SwiperSlide key={index} className="flex justify-center p-1">
            <Image
              // loader={imageLoader}
              src={imageErrors[index] ? '/broken-image.svg' : picture}
              width={120}
              height={120}
              alt={`thumbnail-${index}`}
              onClick={() => setSelectedImage(index)}
              onError={() => onImageError(index)}
              className={classNames(
                'h-[162px] w-[170px] cursor-pointer rounded-md object-cover',
                selectedImage === index ? 'ring-4 ring-blue-400' : 'ring-0',
                imageErrors[index] ? 'bg-slate-400' : ''
              )}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Suspense>
  );
}
